const base = {
    // egg: 'https://site.hqaiot.com',测试
    egg: 'https://universal.billicomm.cn/',
}

export default base